export default __webpack_public_path__ + "static/media/indicator-sect4-after-2-left.4e8bdf6e.svg";